import React from "react";
import * as APIStore from "../store/APIStore";
import { Badge } from '@material-ui/core';
import { NotificationsNone } from '@material-ui/icons';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import { yellow } from '@material-ui/core/colors';

export interface DrawerBadgeProps {
    notificationState: APIStore.NotificationCountState,
}

export const DrawerBadge = (props: DrawerBadgeProps) => {

    let { UnreadCount, isLoaded, isErrored, isLoading } = props.notificationState;

    if (isLoaded && !isErrored) {
        return (
            <Badge badgeContent={UnreadCount} color="error">
                <NotificationsNone />
            </Badge>)
    }

    if (isLoading) {
        return (
            <Badge>
                <HourglassEmptyIcon />
            </Badge>)
    }

    if (isErrored) {
        return (
            <Badge badgeContent={0} >
                <ReportProblemIcon style={{ color: yellow[500] }} />
            </Badge>)
    }


    return (
        <Badge badgeContent={0} >
            <NotificationsNone />
        </Badge>)
}